import {useEffect, useMemo, useState} from "react";
import {HStack, VStack, Field, Switch, Icon, Text, Button} from "@chakra-ui/react";
import {HiCheck, HiX} from "react-icons/hi";
import ConditionalField from "@/components/ui/scenarios/ConditionalField";
import uuid4 from "uuid4";
import {HiOutlinePlus} from "react-icons/hi2";

const emptyTransition = {
    id: uuid4().toString(),
    destination: "",
    condition: ""
}

const createEmptyTransition = () => {
    return {
        id: uuid4().toString(),
        destination: "",
        condition: ""
    }
}

const ConditionalTransitionsPanel = ({intents,
                                      entities,
                                      onChange,
                                      initialTransitions = [],
                                      conditional = true,
                                      toggleConditional
                                     }) => {
    const [transitions, setTransitions] = useState([...initialTransitions]);


    
    useEffect(() => {
        onChange(transitions);
    }, [transitions]);
    
    const selectableEntities = useMemo(() => {
        return entities?.map((entity) => {
            return {id: entity.name, display: entity.name.replace("@", "")}
        })
    }, [entities]);

    const selectableIntents = useMemo(() => {
        return intents?.map((intent) => {
            return {id: intent.id, name: `@${intent.name}`}
        })
    }, [intents]);


    const handleSetTransition = (values, index) => {
        const array = [...transitions];

        array[index] = values;
        setTransitions(array);
    }

    const handleSetConditionalSwitch = (value) => {
        toggleConditional(value);
    }

    const handleRemoveTransition = (id) => {
        const array = [...transitions];
        const newArray = array.filter(t => t.id !== id);
        setTransitions(newArray);
    }

    const handleAddTransition = () => {
        setTransitions(prev => {
            return [...prev, createEmptyTransition()]
        })
    }

    return (
        <VStack w={'full'}>
            <HStack w={'full'}>
                <Field.Root required>
                    <Field.Label color={'white'} fontSize={18}>
                        Conditional transitions
                    </Field.Label>
                    <Field.HelperText>
                        Create conditional rules that decide what happens next depending on the user’s input.
                    </Field.HelperText>
                </Field.Root>

                <Switch.Root checked={conditional} onCheckedChange={(e) => handleSetConditionalSwitch(e.checked)}
                             colorPalette={'green'}>
                    <Switch.HiddenInput/>
                    <Switch.Control>
                        <Switch.Thumb>
                            <Switch.ThumbIndicator fallback={<HiX color="black"/>}>
                                <HiCheck/>
                            </Switch.ThumbIndicator>
                        </Switch.Thumb>
                    </Switch.Control>
                    <Switch.Label/>
                </Switch.Root>
            </HStack>
            {transitions?.map((item, index) =>
                <ConditionalField 
                    key={item.id} 
                    index={index} 
                    onChange={handleSetTransition} 
                    value={item}
                    entities={selectableEntities} 
                    intents={selectableIntents}
                    onRemoveClick={handleRemoveTransition}
                    canDelete={transitions.length > 1}
                />
            )}
            <Button variant="outlined" textDecoration='unset' onClick={handleAddTransition} alignSelf={'end'}>
                <Icon fontSize={46}>
                    <HiOutlinePlus/>
                </Icon>
                <Text>Add condition</Text>
            </Button>
        </VStack>
    )

}

export default ConditionalTransitionsPanel;